export const state = () => ({
  modalVisible: false,
  resource: undefined
})

export const mutations = {
  setModalVisible(state, modalVisible) {
    state.modalVisible = modalVisible
  },

  setResource(state, resource) {
    state.resource = resource
  }
}

export const actions = {
  open({ commit }, { resource }) {
    commit('setModalVisible', true)
    commit('setResource', resource)
  },

  close({ commit }) {
    commit('setModalVisible', false)
    commit('setResource', undefined)
  }
}

export const getters = {
  isVisible(state) { return state.modalVisible },

  currentResource(state) { return state.resource },
}
